var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"target":"_blank","href":"https://www.alt21.com/wp-content/uploads/2021/06/ALT21_Terms_and_Conditions_June_2023.pdf"}},[_vm._v(" Terms and Conditions ")])
}
var staticRenderFns = []

export { render, staticRenderFns }